<template>
  <div class="indexMainArea">
    <div class="selectSections" id="selectSections">
      <div class="selectedSection" @click="selectSection" id="liveVideo">{{languageStore.get('liveBroadcast')}}</div>
      <div class="section" @click="selectSection" id="recordVideo">{{languageStore.get('videoMinutes')}}</div>
    </div>
    <div class="mainSection">
      <live-video v-show="selectedSection === 'liveVideo'"></live-video>
      <today-live v-show="selectedSection === 'liveVideo'"></today-live>
      <RecordVideoComponent v-show="selectedSection === 'recordVideo'"></RecordVideoComponent>
    </div>
  </div>
</template>

<script setup>
import LiveVideo from "@/components/main/liveVideo/liveVideo.vue";
import TodayLive from "@/components/main/liveVideo/todayLive.vue";
import RecordVideoComponent from "@/components/main/recordVideo/recordVideoComponent.vue";

import {ref} from "vue";
import {useLanguageStore} from "@/pinia";
const languageStore = useLanguageStore();
const selectedSection = ref("liveVideo")

const selectSection = (e)=>{
  const target = e.target;
  const sections =document.getElementById("selectSections");
  const divElements = sections.getElementsByTagName("div");
  for(let i =0; i< divElements.length ; i++){
    divElements[i].classList.replace('selectedSection', 'section');
  }
  target.classList = "selectedSection"
  selectedSection.value = target.id;
}
</script>

<style scoped>
.indexMainArea{
  position: relative;
  border-top: 1px solid #AFAFAF;
  width: 100%;
  height: 100vh;
  background: #EEF1F5;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.selectSections {
  display: flex;
  width: 100%;
  height: 7vh;
  justify-content: center;
  align-items: center;
}
.section {
  font-weight: bold;
  height: 70%;
  margin : 0 15px 0 15px;
  width : 8vw;
  display: flex;
  justify-content: center;
  background: #C7C7C7 ;
  align-items: center;
  cursor : pointer;
}
.selectedSection {
  font-weight: bold;
  height: 70%;
  margin : 0 15px 0 15px;
  width : 8vw;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #052C65 ;
  color : white;
}
.mainSection {
  width: 90vw;
  display: flex;
  flex-direction: column;
  align-items: center
}
</style>
